import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { CurrentMedicationModel } from 'src/app/models/CurrentMedicationModel';
import { CurrentMedicationService } from 'src/app/services/CurrentMedicationService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { DomSanitizer } from '@angular/platform-browser';
import { ItemsService } from 'src/app/services/ItemsService';
import { masterdataService } from 'src/app/services/MasterdataService';
import { HorTypeModel, RadTypeModel } from 'src/app/models/Masterdata.Model';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { CancerTreatmentModel } from 'src/app/models/CancerTreatmentModel';
import { CancerTreatmentService } from 'src/app/services/CancerTreatmentService';
import swal from 'sweetalert2';
import { SurgicalHistoryService } from 'src/app/services/SurgicalHistoryService';
import { SurgTypeModel } from 'src/app/models/SurgicalHistoryModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { CompanyService } from 'src/app/services/CompanyService';
import { CompanyModel } from 'src/app/models/CompanyModel';

@Component({
  selector: 'app-anti-cancer-treatment-entry',
  templateUrl: './anti-cancer-treatment-entry.component.html',
  styleUrls: ['./anti-cancer-treatment-entry.component.css']
})
export class AntiCancerTreatmentEntryComponent implements OnInit {
  patientcode = '' ;
  patientname = '';
  trdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trtime =formatDate(new Date(), 'HH:mm', 'en');
  trlocation = '1' ;
  trtype = '' ;
  trkindid = '';
  trkind = '' ;
  trunit = '';
  trcycleno = '0' ;
  trdayscycle = '0' ;
  trnotes = '' ;
  trstartdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  trdose = 0 ;
  trdosemod = 0;
  trfrac = 0 ;
  trdosefrac = 0 ;
  userid = '' ;
  username = '' ;
  trconsultant = '';
  wk_trkindid = '';
  TreatmentKind = 'Regimen';
  TreatmentNotes = 'Other Specify'
  protocolHD: ProtocolHDModel[] = [];
  ratype: RadTypeModel[] = [];
  hortype : HorTypeModel[]=[];
  doctorsList :DoctorsModel[]=[];
  surtype : SurgTypeModel[]=[];

  chemolist : CancerTreatmentModel[]=[];
  radiolist : CancerTreatmentModel[]=[];
  hormonallist : CancerTreatmentModel[]=[];
  surgrylist : CancerTreatmentModel[]=[];
  targetlist : CancerTreatmentModel[]=[];
  immuneolist : CancerTreatmentModel[]=[];
  companyList : CompanyModel[]=[];
  currentmedication : CurrentMedicationModel[]=[];
  itemsList2: ItemsModel[] =[];
  unitsList: UnitsModel[] = [];

  heddin_cycleno = true;
  heddin_notes = true;
  heddin_enddate = true;
  heddin_dose = true;
  heddin_frac = true;
  heddin_dosfrac = true;
  heddin_hormonal = true;
  heddin_surgry = true;
  heddin_target = true;
  heddin_immuneo = true;
  OriginalDate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  startdate =formatDate(new Date(), 'yyyy-MM-dd', 'en');
  enddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public protocolHDService: ProtocolHDService,
    public storage: LocalStorageService,
    public stores : LkpStoresModel,
    public masterdataService : masterdataService,
    public cancertreatment :CancerTreatmentModel,
    public radio :CancerTreatmentModel,
    public cancertreatmentService : CancerTreatmentService,
    public dialogRef: MatDialogRef<AntiCancerTreatmentEntryComponent>,
    public doctorsService :DoctorsService,
    public itemsService : ItemsService,
    public surtypeservice : SurgicalHistoryService,
    public unitsService : UnitsService,
    public companyService : CompanyService,
  ) { }

  ngOnInit(): void {
    debugger;
    this.retriveDoctorsLookupTop();
    this.retriveUnitsLookupTop();
    this.retriveItemsTop();
    this.retriveCompanyLookupTop()
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.patientname = this.storage.retrieve('stgPatientName');
    this.trdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.trtime =formatDate(new Date(), 'hh:mm aa', 'en');
    this.trtype = this.storage.retrieve('stgTrType');

    this.OriginalDate = formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.trlocation = this.storage.retrieve('stgLocation');

    this.Change_Treatment_Type();
}

msgError (){
            swal({
            title: 'Please Enter the Location',
            type: 'error',
            showConfirmButton: false,
            timer: 1500
            });
}







retriveDoctorsLookupTop() {
    this.doctorsList=[]
    this.doctorsService.getDoctorsLookupTopDep('1', 'Oncology')
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsList[i] = data[i];
        }

      });
}
retriveCompanyLookupTop() {
    this.companyService.getLocationLookupTop('1').subscribe((data: CompanyModel[]) => {

        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
Change_Treatment_Type(){
  if(this.trtype == '1'){

    this.heddin_cycleno = false;
    this.heddin_notes = false;
    this.heddin_enddate = false;
    this.heddin_dose = true;
    this.heddin_frac = true;
    this.heddin_dosfrac = true;
    this.heddin_hormonal = true;
    this.heddin_surgry = true;
    this.heddin_target = true;
    this.heddin_immuneo = true;
    this.TreatmentKind ='Regimen';
    this.TreatmentNotes ='Notes';
  }
  if(this.trtype == '2'){
    this.masterdataService.getRadTypeLookupTopGov().subscribe((data1: RadTypeModel[]) => {
      this.protocolHD = [];
      for (let i = 0; i < data1.length; i++) {
        this.ratype[i] = data1[i];
         this.protocolHD.push({
        prHdCode : this.ratype[i].radtypecode.toString(),
        prHdName : this.ratype[i].radtypename,
        prHdNotes : this.ratype[i].radtypenotes,
        prHdCycle : 0,
        prHdDays : 0,
        compCode : '1',
        userID : 'sa',
        modifiedDate : null,
        })
      }
    });

    this.heddin_cycleno = true;
    this.heddin_notes = false;
    this.heddin_enddate = false;
    this.heddin_dose = false;
    this.heddin_frac = false;
    this.heddin_dosfrac = false;
    this.heddin_hormonal = true;
    this.heddin_surgry = true;
    this.heddin_target = true;
    this.heddin_immuneo = true;
    this.TreatmentKind ='Technique';
    this.TreatmentNotes ='Notes';
  }
  if(this.trtype == '3'){
    this.masterdataService.getHorTypeLookupTopGov().subscribe((data1: HorTypeModel[]) => {
      this.protocolHD = [];
      for (let i = 0; i < data1.length; i++) {
        this.hortype[i] = data1[i];
         this.protocolHD.push({
        prHdCode : this.hortype[i].hortypecode.toString(),
        prHdName : this.hortype[i].hortypename,
        prHdNotes : this.hortype[i].hortypenotes,
        prHdCycle : 0,
        prHdDays : 0,
        compCode : '1',
        userID : 'sa',
        modifiedDate : null,
        })
      }
    });


    this.heddin_cycleno = true;
    this.heddin_notes = false;
    this.heddin_enddate = false;
    this.heddin_dose = true;
    this.heddin_frac = true;
    this.heddin_dosfrac = true;
    this.heddin_hormonal = false;
    this.heddin_surgry = true;
    this.heddin_target = true;
    this.heddin_immuneo = true;
    this.TreatmentKind ='Hormone Type';
  }
  if(this.trtype == '4'){
    this.TreatmentNotes ='Notes';
    this.surtypeservice.LookupSurgicalHistory().subscribe((data1: SurgTypeModel[]) => {
      this.protocolHD = [];
      for (let i = 0; i < 3; i++) {
        this.surtype[i] = data1[i];
         this.protocolHD.push({
        prHdCode : this.surtype[i].surtypecode.toString(),
        prHdName : this.surtype[i].surtypename,
        prHdNotes : this.surtype[i].surtypenotes,
        prHdCycle : 0,
        prHdDays : 0,
        compCode : '1',
        userID : 'sa',
        modifiedDate : null,
        })

      }
    });

    this.heddin_cycleno = true;
    this.heddin_notes = false;
    this.heddin_enddate = true;
    this.heddin_dose = true;
    this.heddin_frac = true;
    this.heddin_dosfrac = true;
    this.heddin_hormonal = true;
    this.heddin_surgry = false;
    this.heddin_target = true;
    this.heddin_immuneo = true;
    this.TreatmentKind ='Surgery Type';
  }
  if(this.trtype == '5'){
    this.masterdataService.getHorTypeLookupTopGov().subscribe((data1: HorTypeModel[]) => {
      this.protocolHD = [];
      for (let i = 0; i < data1.length; i++) {
        this.hortype[i] = data1[i];
         this.protocolHD.push({
        prHdCode : this.hortype[i].hortypecode.toString(),
        prHdName : this.hortype[i].hortypename,
        prHdNotes : this.hortype[i].hortypenotes,
        prHdCycle : 0,
        prHdDays : 0,
        compCode : '1',
        userID : 'sa',
        modifiedDate : null,
        })
      }
    });

    this.heddin_cycleno = true;
    this.heddin_notes = false;
    this.heddin_enddate = false;
    this.heddin_dose = true;
    this.heddin_frac = true;
    this.heddin_dosfrac = true;
    this.heddin_hormonal = true;
    this.heddin_surgry = true;
    this.heddin_target = false;
    this.heddin_immuneo = true;
    this.TreatmentKind ='Type';
  }

  if(this.trtype == '6'){
    this.masterdataService.getHorTypeLookupTopGov().subscribe((data1: HorTypeModel[]) => {
      this.protocolHD = [];
      for (let i = 0; i < data1.length; i++) {
        this.hortype[i] = data1[i];
         this.protocolHD.push({
        prHdCode : this.hortype[i].hortypecode.toString(),
        prHdName : this.hortype[i].hortypename,
        prHdNotes : this.hortype[i].hortypenotes,
        prHdCycle : 0,
        prHdDays : 0,
        compCode : '1',
        userID : 'sa',
        modifiedDate : null,
        })



      }
    });

    this.heddin_cycleno = true;
    this.heddin_notes = false;
    this.heddin_enddate = false;
    this.heddin_dose = true;
    this.heddin_frac = true;
    this.heddin_dosfrac = true;
    this.heddin_hormonal = true;
    this.heddin_surgry = true;
    this.heddin_target = true;
    this.heddin_immuneo = false;
    this.TreatmentKind ='Type';
  }
  this.RetriveData();

}
RetriveData(){
//debugger;
if (this.trtype == '1'){
        this.chemolist=[]
        this.cancertreatmentService.getCancerTreatment(this.patientcode, this.trdate,this.trtype).subscribe({
        next: (data: CancerTreatmentModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.chemolist[i] = data[i];
            this.trconsultant = data[i].trconsultant;
            this.trtype = data[i].trtype;
            if(data[i].trstartdate !=null){this.chemolist[i].trstartdate=formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en')};
            this.unitsService.getUnits(data[i].trunit,'1').subscribe((data1: UnitsModel) => {
              this.chemolist[i].trunitname = data1.unName;
            });
          }


        },
        error: (error) => {
          // Handle any actual errors here, if needed.  For example:
          console.error("Error fetching nurse assessment:", error);
          // You might also want to display an error message to the user.
        },
        complete: () => {
          // This block executes after a successful completion (even if data is null/undefined).
            if (!this.trlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
                this.trlocation = '1';
                this.trdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
            }
        }
      });
    }
if (this.trtype == '2'){
      this.radiolist=[]
      this.cancertreatmentService.getCancerTreatment(this.patientcode, this.trdate,this.trtype).subscribe({
      next: (data: CancerTreatmentModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.radiolist[i] = data[i];
          this.trconsultant = data[i].trconsultant;
          this.trtype = data[i].trtype;
          if(data[i].trstartdate !=null){this.radiolist[i].trstartdate=formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en')};
          if(data[i].trenddate !=null){this.radiolist[i].trenddate=formatDate(data[i].trenddate, 'yyyy-MM-dd', 'en')};

          this.unitsService.getUnits(data[i].trunit,'1').subscribe((data1: UnitsModel) => {
            this.radiolist[i].trunitname = data1.unName;
          });
        }
      },
      error: (error) => {
        // Handle any actual errors here, if needed.  For example:
        console.error("Error fetching nurse assessment:", error);
        // You might also want to display an error message to the user.
      },
      complete: () => {
        // This block executes after a successful completion (even if data is null/undefined).
          if (!this.trlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
              this.trlocation = '1';
              this.trdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
          }
      }
    });
   }
if (this.trtype == '3'){
    this.hormonallist=[]
    this.cancertreatmentService.getCancerTreatment(this.patientcode, this.trdate,this.trtype).subscribe({
    next: (data: CancerTreatmentModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.hormonallist[i] = data[i];
        this.trconsultant = data[i].trconsultant;
        this.trtype = data[i].trtype;
        if(data[i].trstartdate !=null){this.hormonallist[i].trstartdate=formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en')};

      }
    },
    error: (error) => {
      // Handle any actual errors here, if needed.  For example:
      console.error("Error fetching nurse assessment:", error);
      // You might also want to display an error message to the user.
    },
    complete: () => {
      // This block executes after a successful completion (even if data is null/undefined).
        if (!this.trlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
            this.trlocation = '1';
            this.trdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
        }
    }
  });
 }
 if (this.trtype == '4'){
  this.surgrylist=[]
  this.cancertreatmentService.getCancerTreatment(this.patientcode, this.trdate,this.trtype).subscribe({
  next: (data: CancerTreatmentModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.surgrylist[i] = data[i];
      this.trconsultant = data[i].trconsultant;
      this.trtype = data[i].trtype;
      if(data[i].trstartdate !=null){this.surgrylist[i].trstartdate=formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en')};

    }
  },
  error: (error) => {
    // Handle any actual errors here, if needed.  For example:
    console.error("Error fetching nurse assessment:", error);
    // You might also want to display an error message to the user.
  },
  complete: () => {
    // This block executes after a successful completion (even if data is null/undefined).
      if (!this.trlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
          this.trlocation = '1';
          this.trdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
      }
  }
});
}
if (this.trtype == '5'){
  this.targetlist=[]
  this.cancertreatmentService.getCancerTreatment(this.patientcode, this.trdate,this.trtype).subscribe({
  next: (data: CancerTreatmentModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.targetlist[i] = data[i];
      this.trconsultant = data[i].trconsultant;
      this.trtype = data[i].trtype;
      if(data[i].trstartdate !=null){this.targetlist[i].trstartdate=formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en')};

    }
  },
  error: (error) => {
    // Handle any actual errors here, if needed.  For example:
    console.error("Error fetching nurse assessment:", error);
    // You might also want to display an error message to the user.
  },
  complete: () => {
    // This block executes after a successful completion (even if data is null/undefined).
      if (!this.trlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
          this.trlocation = '1';
          this.trdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
      }
  }
});
}
if (this.trtype == '6'){
  this.immuneolist=[]
  this.cancertreatmentService.getCancerTreatment(this.patientcode, this.trdate,this.trtype).subscribe({
  next: (data: CancerTreatmentModel[]) => {
    for (let i = 0; i < data.length; i++) {
      this.immuneolist[i] = data[i];
      this.trconsultant = data[i].trconsultant;
      this.trtype = data[i].trtype;
      if(data[i].trstartdate !=null){this.immuneolist[i].trstartdate=formatDate(data[i].trstartdate, 'yyyy-MM-dd', 'en')};

    }
  },
  error: (error) => {
    // Handle any actual errors here, if needed.  For example:
    console.error("Error fetching nurse assessment:", error);
    // You might also want to display an error message to the user.
  },
  complete: () => {
    // This block executes after a successful completion (even if data is null/undefined).
      if (!this.trlocation) {  // Check if visitlocation is undefined or null.  Could also check for an empty string "" if that's a possibility.
          this.trlocation = '1';
          this.trdate = formatDate(this.OriginalDate, 'yyyy-MM-dd', 'en');
      }
  }
});
}
}

New_Date(){
  this.trkindid = '' ;
  this.trkind = '' ;
  this.trcycleno = '0' ;
  this.trdayscycle = '0' ;
  this.trnotes = '' ;
  this.trstartdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.trenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.trdose = 0 ;
  this.trdosemod = 0 ;
  this.trfrac = 0 ;
  this.trdosefrac = 0 ;
 // this.trconsultant = '';
  this.trunit = '';
}
submitCMedication(){

    debugger;

  if (this.trtype == '' || this.trtype == null){
    return;
  }

    this.trtime  =formatDate(new Date(), 'HH:mm', 'en');
    const str1 = formatDate(this.trdate, 'yyyy-MM-dd', 'en') + 'T' + this.trtime+':00.000Z';

    this.cancertreatment.patientcode= this.patientcode;
    this.cancertreatment.trdate= this.trdate;
    this.cancertreatment.trtime= str1;
    this.cancertreatment.trlocation= this.trlocation;
    this.cancertreatment.trtype= this.trtype;
    this.cancertreatment.trkindid= this.trkindid;
    this.Get_ItemName();
    this.cancertreatment.trkind= this.trkind;
    this.cancertreatment.trunit= this.trunit;

    this.cancertreatment.trcycleno= this.trcycleno.toString();
    this.cancertreatment.trdayscycle= this.trdayscycle.toString();
    this.cancertreatment.trnotes= this.trnotes;
    this.cancertreatment.trstartdate= this.trstartdate;
    this.cancertreatment.trenddate= this.trenddate;
    this.cancertreatment.trdose= this.trdose;
    this.cancertreatment.trdosemod= this.trdosemod;
    this.cancertreatment.trfrac= this.trfrac;
    this.cancertreatment.trdosefrac= this.trdosefrac;
    this.cancertreatment.userid= this.storage.retrieve('stguserId');
    this.cancertreatment.username= this.storage.retrieve('stgusername');
    this.cancertreatment.trconsultant= this.trconsultant;

    this.cancertreatmentService.AddCancerTreatment(this.cancertreatment).subscribe(data => {

        this.mesgSave();
        this.RetriveData();
        this.New_Date();
        },
          error => { alert(error); }
        );

}
submitRadio(){

  if (this.trtype == '' || this.trtype == null){
    return;
  }
    this.trtime  =formatDate(new Date(), 'HH:mm', 'en');
    const str1 = formatDate(this.trdate, 'yyyy-MM-dd', 'en') + 'T' + this.trtime+':00.000Z';

    this.radio.patientcode= this.patientcode;
    this.radio.trdate= this.trdate;
    this.radio.trtime= str1;
    this.radio.trlocation= this.trlocation;
    this.radio.trtype= this.trtype;
    this.radio.trkindid= this.trkindid;
    this.radio.trkind= this.trkind;
    this.radio.trunit= this.trunit;

    this.radio.trcycleno= this.trcycleno.toString();
    this.radio.trdayscycle= this.trdayscycle.toString();
    this.radio.trnotes= this.trnotes;
    this.radio.trstartdate= this.trstartdate;
    this.radio.trenddate= this.trenddate;
    this.radio.trdose= this.trdose;
    this.radio.trdosemod= this.trdosemod;
    this.radio.trfrac= this.trfrac;
    this.radio.trdosefrac= this.trdosefrac;
    this.radio.userid= this.storage.retrieve('stguserId');
    this.radio.username= this.storage.retrieve('stgusername');
    this.radio.trconsultant= this.trconsultant;

    this.cancertreatmentService.AddCancerTreatment(this.cancertreatment).subscribe(data => {

        this.mesgSave();
        this.RetriveData();
        this.New_Date();
        },
          error => { alert(error); }
        );
}
submitHormonal(){

  if (this.trtype == '' || this.trtype == null){
    return;
  }
    this.trtime  =formatDate(new Date(), 'HH:mm', 'en');
    const str1 = formatDate(this.trdate, 'yyyy-MM-dd', 'en') + 'T' + this.trtime+':00.000Z';

    this.radio.patientcode= this.patientcode;
    this.radio.trdate= this.trdate;
    this.radio.trtime= str1;
    this.radio.trlocation= this.trlocation;
    this.radio.trtype= this.trtype;
    this.radio.trkindid= this.trkind;
    this.radio.trkind= this.trkindid;
    this.radio.trkindid= this.trkindid;
    this.radio.trunit= this.trunit;

    this.radio.trcycleno= this.trcycleno;
    this.radio.trdayscycle= this.trdayscycle;
    this.radio.trnotes= this.trnotes;
    this.radio.trstartdate= this.trstartdate;
    this.radio.trenddate= this.trenddate;
    this.radio.trdose= this.trdose;
    this.radio.trdosemod= this.trdosemod;
    this.radio.trfrac= this.trfrac;
    this.radio.trdosefrac= this.trdosefrac;
    this.radio.userid= this.storage.retrieve('stguserId');
    this.radio.username= this.storage.retrieve('stgusername');
    this.radio.trconsultant= this.trconsultant;

    this.cancertreatmentService.AddCancerTreatment(this.cancertreatment).subscribe(data => {

        this.mesgSave();
        this.RetriveData();
        this.New_Date();
        },
          error => { alert(error); }
        );
}
submitTrget(){


  if (this.trtype == '' || this.trtype == null){
    return;
  }
    this.trtime  =formatDate(new Date(), 'HH:mm', 'en');
    const str1 = formatDate(this.trdate, 'yyyy-MM-dd', 'en') + 'T' + this.trtime+':00.000Z';

    this.radio.patientcode= this.patientcode;
    this.radio.trdate= this.trdate;
    this.radio.trtime= str1;
    this.radio.trlocation= this.trlocation;
    this.radio.trtype= this.trtype;
    this.radio.trkindid= this.trnotes;
    this.radio.trkind= this.trnotes;
    this.radio.trunit= this.trunit;

    this.radio.trcycleno= this.trcycleno;
    this.radio.trdayscycle= this.trdayscycle;
    this.radio.trnotes= this.trnotes;
    this.radio.trstartdate= this.trstartdate;
    this.radio.trenddate= this.trenddate;
    this.radio.trdose= this.trdose;
    this.radio.trdosemod= this.trdosemod;
    this.radio.trfrac= this.trfrac;
    this.radio.trdosefrac= this.trdosefrac;
    this.radio.userid= this.storage.retrieve('stguserId');
    this.radio.username= this.storage.retrieve('stgusername');
    this.radio.trconsultant= this.trconsultant;

    this.cancertreatmentService.AddCancerTreatment(this.cancertreatment).subscribe(data => {

        this.mesgSave();
        this.RetriveData();
        this.New_Date();
        },
          error => { alert(error); }
        );
}

  mesgSave() {
            swal({
            title: 'Your work has been saved',

            type: 'success',
            showConfirmButton: false,

            timer: 1500
            });
}

  openDialogViwer(){

  }
  Exit_Data(){
    this.dialogRef.close();
}
retriveUnitsLookupTop() {
  this.unitsService.getUnitsLookupTop('1')
    .subscribe((data: UnitsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.unitsList[i] = data[i];
      }
      //console.log(data);
    });
}
retriveItemsTop() {

  this.itemsService.getItemsLookupCat('All') .subscribe((data: ItemsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.itemsList2[i] = data[i];
      }
    });
}
Get_ItemName(){
  this.itemsService.getitems(this.trkindid,'1').subscribe((data: ItemsModel) => {
    this.trkind = data.itTName;
    debugger;

  });
  }
SelectChemo(pro : CancerTreatmentModel){

  this.trkindid= pro.trkindid;
  if (this.trtype !='2') this.Get_ItemName();
  this.trunit= pro.trunit;
  this.trcycleno= pro.trcycleno;
  this.trdayscycle= pro.trdayscycle;
  this.trnotes= pro.trnotes;
  this.trstartdate= pro.trstartdate;
  this.trdose= pro.trdose;
  this.trdosemod= pro.trdosemod;
  this.trkind= pro.trkind;


}
Selecthormonal(pro : CancerTreatmentModel){

  this.trkindid= pro.trkind;
  this.trcycleno= pro.trcycleno;
  this.trdayscycle= pro.trdayscycle;
  this.trnotes= pro.trnotes;
  this.trstartdate= pro.trstartdate;
  this.trdose= pro.trdose;
  this.trdosemod= pro.trdosemod;

}
MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteChemo();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
DeleteChemo(){
  //console.log("Date:",this.trdate,this.patientcode,this.trtype,this.trkindid)
  this.cancertreatmentService.deleteCancerTreatment(this.trdate,this.patientcode,this.trtype,this.trkindid).subscribe(
    (data: CancerTreatmentModel) => {
      this.RetriveData();

    }
  );

  this.trkind = '' ;
  this.trkindid = '' ;
  this.trunit = '';
  this.trcycleno = '' ;
  this.trdayscycle = '' ;
  this.trnotes = '' ;
  this.trstartdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.trenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.trdose = 0 ;
  this.trdosemod = 0 ;

  this.trfrac = 0 ;
  this.userid = '' ;
  this.username = '' ;

}
MesgDeleteLine(pro : CancerTreatmentModel){
  swal({
    title: 'Are you sure?',
    text: 'You will not be able to recover this record!',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
  }).then(
    () => {
      this.wk_trkindid = pro.trkindid;
      this.DeleteChemoLine();
      swal('Deleted!', 'Your record has been deleted.', 'success');
    },
    function (dismiss) {
      if (dismiss === 'cancel') {
        swal('Cancelled', 'Your record is safe :)', 'error');
      }
    }
  );
}
DeleteChemoLine(){

this.cancertreatmentService.deleteCancerTreatment(this.trdate,this.patientcode,this.trtype,this.wk_trkindid).subscribe(
  (data: CancerTreatmentModel) => {
    this.RetriveData();

  }
);
//this.trkind = '' ;
this.trkindid = '' ;
this.trunit = '';
this.trcycleno = '' ;
this.trdayscycle = '' ;
this.trnotes = '' ;
this.trstartdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.trenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.trdose = 0 ;
this.trdosemod = 0 ;

this.trfrac = 0 ;
this.userid = '' ;
this.username = '' ;

}
}

